<template>
  <div class="story">
    <!-- <Title text="US Paycheck Protection Program" />
    <div class="w3 l1 p">
      See <a href="http://subject.space/where-were-ppp-loans/">here</a> for
      previous anlaysis of this data. The map below is a proof-of-concept of
      applying this analysis to the entirety of the United States.
    </div>

    <Map
        classString="w4 h3 below"
        variable="pct_with_loan"
        :interactive="false"
        legendStyle="float left large"
        :center="[-118.3037, 33.9722]"
        :zoom="9.45"
        sourceLayer="ppp_full_4"
        sourceURL="mapbox://bellingcat-mapbox.5klcokbi"
        currency="$"
        :ranges="usRanges"
        :interactiveVariables="usInteractiveVariables"
        featureId="zip"
        :zoomStart="8"
      />


    <div class="flex">
      <Map
        classString="w2 h2 below"
        variable="black_and_hispanic"
        :interactive="false"
        legendStyle="below"
        :center="[-118.3037, 33.9822]"
        :zoom="9"
        sourceLayer="ppp_full_4"
        sourceURL="mapbox://bellingcat-mapbox.5klcokbi"
        currency="$"
        :ranges="usRanges"
        :interactiveVariables="usInteractiveVariables"
        featureId="zip"
        :zoomStart="8"
      />

      <div class="m1">
        <Map
          classString="w2 h2 below"
          variable="med_income"
          :interactive="false"
          legendStyle="below"
          :center="[-118.3037, 33.9822]"
          :zoom="9"
          sourceLayer="ppp_full_4"
          sourceURL="mapbox://bellingcat-mapbox.5klcokbi"
          currency="$"
          :ranges="usRanges"
          :interactiveVariables="usInteractiveVariables"
          featureId="zip"
          :zoomStart="8"
        />
      </div>
    </div>


    <div class="flex">
      <Map
        classString="w2 h2 below"
        variable="pct_with_loan"
        :interactive="false"
        legendStyle="below"
        :center="[-73.946, 40.7528]"
        :zoom="10"
        sourceLayer="ppp_full_4"
        sourceURL="mapbox://bellingcat-mapbox.5klcokbi"
        currency="$"
        :ranges="usRanges"
        :interactiveVariables="usInteractiveVariables"
        featureId="zip"
        :zoomStart="8"
      />

      <div class="m1">
        <Map
          classString="w2 h2 below"
          variable="black_and_hispanic"
          :interactive="false"
          legendStyle="below"
          :center="[-73.946, 40.7528]"
          :zoom="10"
          sourceLayer="ppp_full_4"
          sourceURL="mapbox://bellingcat-mapbox.5klcokbi"
          currency="$"
          :ranges="usRanges"
          :interactiveVariables="usInteractiveVariables"
          featureId="zip"
          :zoomStart="8"
        />
      </div>
    </div>

    <div class="flex">
      <Map
        classString="w2 h2 below"
        variable="pct_with_loan"
        :interactive="false"
        legendStyle="below"
        :center="[-95.3698, 29.7604]"
        :zoom="10"
        sourceLayer="ppp_full_4"
        sourceURL="mapbox://bellingcat-mapbox.5klcokbi"
        currency="$"
        :ranges="usRanges"
        :interactiveVariables="usInteractiveVariables"
        featureId="zip"
        :zoomStart="8"
      />

      <div class="m1">
        <Map
          classString="w2 h2 below"
          variable="med_income"
          :interactive="false"
          legendStyle="below"
          :center="[-95.3698, 29.7604]"
          :zoom="10"
          sourceLayer="ppp_full_4"
          sourceURL="mapbox://bellingcat-mapbox.5klcokbi"
          currency="$"
          :ranges="usRanges"
          :interactiveVariables="usInteractiveVariables"
          featureId="zip"
          :zoomStart="8"
        />
      </div>
    </div>

    <Map
      classString="w4 h3 below"
      variable="pct_with_loan"
      :interactive="true"
      legendStyle="below"
      :center="[-74.006, 40.7128]"
      :zoom="8"
      sourceLayer="US_county"
      sourceURL="mapbox://bellingcat-mapbox.dq99feig"
      currency="$"
      :ranges="usRanges"
      :interactiveVariables="usInteractiveVariables"
      featureId="county"
      :zoomStart="5"
    />

    <Title text="UK coronavirus aid" />

    <div class="w3 l1 p">
      This is a proof-of-concept of the UK dataset. It will need some further
      analysis to find narratives and guide the reader through what this data
      actually indicates. Some proof of concept points are below.
    </div>
    <div class="w4 l0 p">
      The Coronavirus Job Retention Scheme is a UK program that supports
      employees furloughed due to coronavirus. However, the percentage of
      eligible employees recieving this aid is not equal throughout the UK. For
      example,
      <span class="preset" @click="set([-0.1, 51.45], 9, 'cjrs')"
        >in London there are significant disparities between the takeup rate in
        the north and south</span
      >. However, unlike the US coronavirus aid, these disparities are not
      neatly correlated with
      <span class="preset" @click="set([-0.1, 51.45], 9, 'income')"
        >income</span
      >
      or
      <span class="preset" @click="set([-0.1, 51.45], 9, 'pct_white')"
        >race</span
      >.
    </div>

    <div class="w4 l0 p">
      There are other coronavirus relief programs in the UK as well, such as the
      Retail, Hospitality, and Leisure grant. This too was recieved unevenly. By
      dividing the number of grants by the number of businesses in those
      sectors, an approximate takeup rate can be calculated for this program.
      <span class="preset" @click="set([-1.5, 53.8], 7.5, 'pct_hosp')"
        >In North England, there is an obvious discrepancy between certain
        regions.</span
      >
    </div>
    <Map
      classString="w4 h3 below"
      :variable="ukVariable"
      :interactive="true"
      legendStyle="below"
      :center="ukCenter"
      :zoom="ukZoom"
      sourceLayer="UK8"
      sourceURL="mapbox://bellingcat-mapbox.7wb18v24"
      currency="£"
      :ranges="ukRanges"
      :interactiveVariables="ukInteractiveVariables"
      featureId="parliamentary_constituency"
      :zoomStart="6"
    />

    <Map
      classString="w4 h3"
      :variable="'cjrs'"
      :interactive="false"
      legendStyle="float right"
      :center="[-1.5929, 51.1012]"
      :zoom="7"
      sourceLayer="UK8"
      sourceURL="mapbox://bellingcat-mapbox.7wb18v24"
      currency="£"
      :ranges="ukRanges"
      :interactiveVariables="ukInteractiveVariables"
      featureId="parliamentary_constituency"
      :zoomStart="9"
    />

    <Map
      classString="w4 h3"
      :variable="'seiss'"
      :interactive="false"
      legendStyle="float right"
      :center="[-1.5929, 51.1012]"
      :zoom="7"
      sourceLayer="UK8"
      sourceURL="mapbox://bellingcat-mapbox.7wb18v24"
      currency="£"
      :ranges="ukRanges"
      :interactiveVariables="ukInteractiveVariables"
      featureId="parliamentary_constituency"
      :zoomStart="9"
    />

    <div class="flex">
      <Map
        classString="w2 h2 below"
        :variable="'asian_pct'"
        :interactive="false"
        legendStyle="below"
        :center="[-1.7529, 51.1012]"
        :zoom="6.01"
        sourceLayer="UK8"
        sourceURL="mapbox://bellingcat-mapbox.7wb18v24"
        currency="£"
        :ranges="ukRanges"
        :interactiveVariables="ukInteractiveVariables"
        featureId="parliamentary_constituency"
        :zoomStart="9"
      />

      <div class="m1">
        <Map
          classString="w2 h2 below"
          :variable="'income'"
          :interactive="false"
          legendStyle="below"
          :center="[-1.7529, 51.1012]"
          :zoom="6.01"
          sourceLayer="UK8"
          sourceURL="mapbox://bellingcat-mapbox.7wb18v24"
          currency="£"
          :ranges="ukRanges"
          :interactiveVariables="ukInteractiveVariables"
          featureId="parliamentary_constituency"
          :zoomStart="9"
        />
      </div>
    </div>

    <Map
      classString="w2 h2 below"
      :variable="'pct_hosp_bus'"
      :interactive="false"
      legendStyle="below"
      :center="[-1.7529, 51.1012]"
      :zoom="6.01"
      sourceLayer="UK8"
      sourceURL="mapbox://bellingcat-mapbox.7wb18v24"
      currency="£"
      :ranges="ukRanges"
      :interactiveVariables="ukInteractiveVariables"
      featureId="parliamentary_constituency"
      :zoomStart="9"
    />

    <div class="flex">
      <Map
        classString="w2 h2 below"
        :variable="'pct_total'"
        :interactive="false"
        legendStyle="below"
        :center="[-1.7529, 51.1012]"
        :zoom="6.2"
        sourceLayer="UK8"
        sourceURL="mapbox://bellingcat-mapbox.7wb18v24"
        currency="£"
        :ranges="ukRanges"
        :interactiveVariables="ukInteractiveVariables"
        featureId="parliamentary_constituency"
        :zoomStart="9"
      />

      <div class="m1">
        <Map
          classString="w2 h2 below"
          :variable="'pct_hosp'"
          :interactive="false"
          legendStyle="below"
          :center="[-1.7529, 51.1012]"
          :zoom="6.2"
          sourceLayer="UK8"
          sourceURL="mapbox://bellingcat-mapbox.7wb18v24"
          currency="£"
          :ranges="ukRanges"
          :interactiveVariables="ukInteractiveVariables"
          featureId="parliamentary_constituency"
          :zoomStart="9"
        />
      </div>
    </div>

        <div class="flex">
      <Map
        classString="w2 h2 below"
        :variable="'population'"
        :interactive="false"
        legendStyle="below"
        :center="[-1.7529, 51.3012]"
        :zoom="6.01"
        sourceLayer="UK8"
        sourceURL="mapbox://bellingcat-mapbox.7wb18v24"
        currency="£"
        :ranges="ukRanges"
        :interactiveVariables="ukInteractiveVariables"
        featureId="parliamentary_constituency"
        :zoomStart="9"
      />

      <div class="m1">
        <Map
          classString="w2 h2 below"
          :variable="'seiss_value'"
          :interactive="false"
          legendStyle="below"
          :center="[-1.7529, 51.3012]"
          :zoom="6.01"
          sourceLayer="UK8"
          sourceURL="mapbox://bellingcat-mapbox.7wb18v24"
          currency="£"
          :ranges="ukRanges"
          :interactiveVariables="ukInteractiveVariables"
          featureId="parliamentary_constituency"
          :zoomStart="9"
        />
      </div>
    </div> -->

    <Title text="French coronavirus aid" />

    <div class="w3 l1 p">
      We also examine two sources of French coronavirus aid. The solidarity
      grant program is intended to provide acute relief to small businesses and
      "micro-entrepreneurs." The <em>activité partielle</em> program pays the
      paychecks of certain furloughed workers. The geographical variation in
      these two aid programs tell very different stories.
    </div>
<!-- 
    <Map
      classString="w4 h3 below"
      :variable="'solidarity_pct'"
      :interactive="true"
      legendStyle="below"
      :center="[2.214, 46.227]"
      :zoom="5"
      sourceLayer="FR3"
      sourceURL="mapbox://bellingcat-mapbox.9dc436bd"
      currency=""
      :ranges="frRanges"
      :interactiveVariables="frInteractiveVariables"
      featureId="nom"
      :zoomStart="4"
    /> -->
<!-- 
    <Map
      classString="w4 h3 below"
      :variable="'furlough_pct'"
      :interactive="false"
      legendStyle="france inset"
      :center="[2.214, 46.437]"
      :zoom="5"
      sourceLayer="FR3"
      sourceURL="mapbox://bellingcat-mapbox.9dc436bd"
      currency=""
      :ranges="frRanges"
      :interactiveVariables="frInteractiveVariables"
      featureId="nom"
      :zoomStart="4"
    />

    <div class="flex">
      <Map
        classString="w1 h1 below"
        :variable="'income'"
        :interactive="false"
        legendStyle="france"
        :center="[2.214, 46.657]"
        :zoom="3.3"
        sourceLayer="FR3"
        sourceURL="mapbox://bellingcat-mapbox.9dc436bd"
        currency=""
        :ranges="frRanges"
        :interactiveVariables="frInteractiveVariables"
        featureId="nom"
        :zoomStart="4"
      />

      <div class="m1">
        <Map
          classString="w1 h1 below"
          :variable="'pct_immigrants'"
          :interactive="false"
          legendStyle="france"
          :center="[2.214, 46.657]"
          :zoom="3.3"
          sourceLayer="FR3"
          sourceURL="mapbox://bellingcat-mapbox.9dc436bd"
          currency=""
          :ranges="frRanges"
          :interactiveVariables="frInteractiveVariables"
          featureId="nom"
          :zoomStart="4"
        />
      </div>

      <div class="m1">
        <Map
          classString="w1 h1 below"
          :variable="'pct_employment_2016'"
          :interactive="false"
          legendStyle="france"
          :center="[2.214, 46.657]"
          :zoom="3.3"
          sourceLayer="FR3"
          sourceURL="mapbox://bellingcat-mapbox.9dc436bd"
          currency=""
          :ranges="frRanges"
          :interactiveVariables="frInteractiveVariables"
          featureId="nom"
          :zoomStart="4"
        />
      </div>

      <div class="m1">
        <Map
          classString="w1 h1 below"
          :variable="'density'"
          :interactive="false"
          legendStyle="france wide"
          :center="[2.214, 46.657]"
          :zoom="3.3"
          sourceLayer="FR3"
          sourceURL="mapbox://bellingcat-mapbox.9dc436bd"
          currency=""
          :ranges="frRanges"
          :interactiveVariables="frInteractiveVariables"
          featureId="nom"
          :zoomStart="4"
        />
      </div>
    </div> -->

    <Map
      classString="w4 h3 below"
      :variable="'solidarity_iz'"
      :interactive="false"
      legendStyle="france inset"
      :center="[2.214, 46.437]"
      :zoom="5"
      sourceLayer="FR3"
      sourceURL="mapbox://bellingcat-mapbox.9dc436bd"
      currency=""
      :ranges="frRanges"
      :interactiveVariables="frInteractiveVariables"
      featureId="nom"
      :zoomStart="4"
    />

    <div class="flex">
      <Map
        classString="w2 h2 below"
        :variable="'salaried'"
        :interactive="false"
        legendStyle="below"
        :center="[1.914, 46.727]"
        :zoom="4.45"
        sourceLayer="FR3"
        sourceURL="mapbox://bellingcat-mapbox.9dc436bd"
        currency=""
        :ranges="frRanges"
        :interactiveVariables="frInteractiveVariables"
        featureId="nom"
        :zoomStart="4"
      />

      <div class="m1">
        <Map
          classString="w2 h2 below"
          :variable="'salaried_hosp'"
          :interactive="false"
          legendStyle="below"
          :center="[1.914, 46.727]"
          :zoom="4.45"
          sourceLayer="FR3"
          sourceURL="mapbox://bellingcat-mapbox.9dc436bd"
          currency=""
          :ranges="frRanges"
          :interactiveVariables="frInteractiveVariables"
          featureId="nom"
          :zoomStart="4"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Title from "../components/Title";
import Map from "../components/Map";
import { variables, interactiveVariables } from "../constants/ranges";
import {
  variables as ukRanges,
  interactiveVariables as ukInteractiveVariables,
} from "../constants/ranges_uk";
import {
  variables as frRanges,
  interactiveVariables as frInteractiveVariables,
} from "../constants/ranges_fr";

export default {
  name: "Home",
  components: {
    Title,
    Map,
  },
  data() {
    return {
      ukCenter: [-2, 52],
      ukZoom: 6,
      ukVariable: "cjrs",

      usRanges: variables,
      usInteractiveVariables: interactiveVariables,
      ukRanges,
      ukInteractiveVariables,
      frRanges,
      frInteractiveVariables,
    };
  },
  methods: {
    set(center, zoom, variable) {
      this.ukCenter = center;
      this.ukZoom = zoom;
      this.ukVariable = variable;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../constants/_style.scss";

.preset {
  text-decoration: underline;
  cursor: pointer;
}

.story {
  width: calc(#{$grid} * #{$block-width} * 4 + #{$grid} * #{$gutter-width} * 3);
  margin: calc(#{$grid} * #{$gutter-width});
  overflow-x: none;
}
</style>
